<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="102.021" height="101.723" viewBox="0 0 102.021 101.723">
    <g transform="translate(1.009 1.055)">
      <path :style="{stroke:color}" class="a" d="M101.6,47.242v4.581A49.8,49.8,0,1,1,72.067,6.308" transform="translate(-2 -1.994)"/>
      <path :style="{stroke:color}" class="a" d="M73.738,4,23.94,53.849,9,38.909" transform="translate(25.859 5.991)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CheckIconLg",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #57b98f;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
